import React from 'react';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import './entertainment-video-review-header.scss';

export function EntertainmentVideoReviewHeader({
  isEditMode,
  currentPosition,
  maxPosition,
  title,
  subtitle,
  onCurrentPositionChange
}: {
  isEditMode: boolean,
  currentPosition: number,
  maxPosition: number,
  title: string,
  subtitle: string,
  onCurrentPositionChange: (newPosition: number) => void
}) {
  return (
    <div className="ev-review-header">
      {!isEditMode && (
        <SVGDynamicIcon
          name="chevron-left-custom-fg"
          width={16}
          height={16}
          customColor="grey"
          disabled={currentPosition === 0}
          clickable
          onClick={() => onCurrentPositionChange(currentPosition - 1)}
        />
      )}
      <div className="ev-review-header__title-container">
        <div className="ev-review-header__title">{title}</div>
        {subtitle && (
          <div className="ev-review-header__sub-title">{subtitle}</div>
        )}
      </div>
      {!isEditMode && (
        <SVGDynamicIcon
          name="chevron-right-custom-fg"
          width={16}
          height={16}
          customColor="grey"
          disabled={currentPosition === maxPosition}
          clickable
          onClick={() => onCurrentPositionChange(currentPosition + 1)}
        />
      )}
    </div>
  );
}
